import React from 'react';
import { Form, FormikProps } from 'formik';

import { form, loader, opaque, globalError } from './formik-form.module.scss';
import { config } from '../../config';

import Loader, { ILoaderProps } from '../atoms/loader';
import Error from '../atoms/form/error';

const { statusMap } = config;

interface FormikFormProps {
    className?: string;
    formik: FormikProps<any>;
    successMessage: React.ReactNode;
    loaderType?: 'layer' | 'opaque';
    loaderColor?: ILoaderProps['color'];
}

const FormikForm: React.FC<FormikFormProps> = ({
    className = '',
    formik,
    successMessage,
    loaderType = 'layer',
    loaderColor,
    children,
}) => {
    const { status, errors } = formik;
    return (
        <Form
            className={`
                ${form} 
                ${className} 
                ${status === statusMap.loading ? getLoaderTypeClass(loaderType) : ''}
            `}
        >
            {status === statusMap.loading && (
                <Loader color={loaderColor} className={loader} isAbsolute={true} />
            )}
            {status === statusMap.success ? successMessage : children}
            {status === statusMap.error && errors.global && (
                <Error className={globalError}>{errors.global}</Error>
            )}
        </Form>
    );
};

function getLoaderTypeClass(loaderType: FormikFormProps['loaderType']): string {
    if (loaderType === 'opaque') {
        return opaque;
    }
    return '';
}

export default FormikForm;
